
    import { Component, Inject} from 'ng-metadata/core';
    import {ConfigurationUtil} from '../../../nddUtils/configurationUtil.service';
    import {SearchFieldsService} from '../../search.fields.service';
    import {FacetService} from '../../facet/facet.service';
    import {PrimolyticsService,beacon} from '../../../analytics/primolytics.service';
    import {NewspapersService} from '../../../newspapers/newspapers.service';
    import {AnalyticsUtils} from "../../../nddUtils/analyticsUtils.service";
    const isEqual = require('lodash/isEqual');
    import { SharedSessionStorage } from "../../../infra/sharedSessionStorage.service";
    import { getVid } from '../../../appConfig/appConfigForward';
    import { UserSessionManagerService } from '../../../security/userSessionManager.service';
    import {Cheetah} from '../../../search/cheetah.service';
    import {AuthoritySearchService} from "../../authority/authoritySearch.service";
    import { MappingTablesCache } from '../../../mappingTablesCache/mappingTablesCache.service';
    import { StorageUtil } from '../../../infra/storageUtil.service';

    @Component({
            "selector": "prm-search-result-sort-by",
            templateUrl: 'components/search/searchResult/searchResultSortBy/searchResultSortBy.html'
        })


     export class SearchResultSortBy {
        private myOptions: any;

        constructor(private configurationUtil: ConfigurationUtil,
                    private searchFieldsService: SearchFieldsService,
                    private authoritySearchService: AuthoritySearchService,
                    private mappingTablesCache: MappingTablesCache,
                    private facetService: FacetService, private primolyticsService: PrimolyticsService,
                    @Inject('$http') private $http: ng.IHttpService,
                    @Inject('restBaseURLs') private restBaseURLs,
                    @Inject('$stateParams') private $stateParams: ng.ui.IStateParamsService,
                    private sharedSessionStorage: SharedSessionStorage,
                    private newspapersService: NewspapersService,
                    private analyticsUtils: AnalyticsUtils,
                    private storageUtil: StorageUtil,
                    private cheetahService: Cheetah,
                    private userSessionManagerService: UserSessionManagerService) {

            this.myOptions = this.configurationUtil
                .getBriefResultConfiguration()
                .sortby.split(',')
                .filter((value, index, arr) => {
                    return value !== 'popularity'
                })
                .map(this.createSortByMapping);

            if (this.authoritySearchService.isAuthorityState()) {
                this.myOptions = this.authoritySearchSortList;
            }

            if (this.newspapersService.isNewspapersSearch()) {
                this.myOptions = this.myOptions.filter((sort) => {
                    return ['rank', 'date', 'date_d', 'date_a', 'date2'].indexOf(sort.value) !== -1;
                });
            }

            let journalOrDatabasesValue = this.$stateParams['journals'] || this.$stateParams['databases']; // can't be both in the same time
            if (journalOrDatabasesValue) {
                this.myOptions = [];
                if (journalOrDatabasesValue.split(",")[0] === 'any') {
                    this.myOptions.push(this.createSortByMapping('rank'));
                    this.myOptions.push(this.createSortByMapping('title'));
                }
            }

            if (!this.sortBy) {
                this.sortBy = this.myOptions[0].value; //init sort by
            }

            if (this.cheetahService.isPatronsDefaultSortEnabled() && this.cheetahService.usePatronsDefaultSort()) {
                this.sortBy = this.storageUtil.sessionStorage.getItem('patronsDefaultSort'); //init sort by from DB
            }
        }

        /* getters & setters */
        get options() {
            return this.myOptions;
        };

        @beacon({'p': 'sort'})
        get sortBy() {
            return this.searchFieldsService.sortby;
        };

        set sortBy(sortBy) {
            this.searchFieldsService.sortby = sortBy;
            this.authoritySearchService.sortby = sortBy;
        };

        private get authoritySearchSortList() {
            return this.authoritySearchSortObjFromConf.map(mt => ({value: mt.target, text: mt.target}));
        }

        private get authoritySearchSortObjFromConf() {
            return this.mappingTablesCache.findByProperties(this.mappingTablesCache.tables.AUTHORITY_SEARCH_SORT,
                {source1: getVid()});
        }

        private createSortByMapping(e) {
            return {
                value: e,
                text: e
            };

        }

        private onSortChange() {
            this.sendAnalytics();
            if (this.cheetahService.isPatronsDefaultSortEnabled()) {
                this.updatePatronsDefaultSortInDB(this.sortBy);
            }
            this.facetService.facetSearch({sortby: this.sortBy, came_from: 'sort'});
        }

        public updatePatronsDefaultSortInDB(patronsDefaultSort) {
            this.storageUtil.sessionStorage.setItem('patronsDefaultSort', this.sortBy);
            if (!this.userSessionManagerService.isGuest()) {
                let payload = {
                    'vid': getVid(),
                    'patronsDefaultSort': patronsDefaultSort
                };
                this.$http.post(this.restBaseURLs.userSettingsBaseURL, payload);
            }
        }

        private sendAnalytics() {
            let payload = this.getAnalyticsPayload();
            this.analyticsUtils.trackUsage(this.analyticsUtils.eventsNames.SORT, payload);
        }

        private getAnalyticsPayload() {
            return {
                'Sort Type': this.getSortType()
            }
        }

        private getSortType() {
            if (isEqual(this.searchFieldsService.sortby,'date_d')) {
                return 'Date-Newest';
            }
            if (isEqual(this.searchFieldsService.sortby,'date_a')) {
                return 'Date-Oldest';
            }
            if (isEqual(this.searchFieldsService.sortby,'rank')) {
                return 'Relevance';
            }

            return this.searchFieldsService.sortby.charAt(0).toUpperCase() + this.searchFieldsService.sortby.slice(1); //capitalizing the first letter
        }

     }




// WEBPACK FOOTER //
// ./src/main/webapp/components/search/searchResult/searchResultSortBy/searchResultSortBy.directive.ts